import { useEffect, useState } from 'react';

const ACTIVE_LEAGUE_STORAGE_KEY = 'leaguerunner-active-league-id';
const ACTIVE_LEAGUE_CHANGE_EVENT = 'leaguerunner:active-league-changed';

const normalizeLeagueId = (leagueId) => {
  if (!leagueId) return '';
  return String(leagueId).trim();
};

export const getStoredActiveLeagueId = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return normalizeLeagueId(window.localStorage.getItem(ACTIVE_LEAGUE_STORAGE_KEY));
};

const emitActiveLeagueChange = (leagueId = '') => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(ACTIVE_LEAGUE_CHANGE_EVENT, {
    detail: { leagueId: normalizeLeagueId(leagueId) },
  }));
};

export const setStoredActiveLeagueId = (leagueId) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedLeagueId = normalizeLeagueId(leagueId);
  if (!normalizedLeagueId) {
    window.localStorage.removeItem(ACTIVE_LEAGUE_STORAGE_KEY);
    emitActiveLeagueChange('');
    return;
  }

  window.localStorage.setItem(ACTIVE_LEAGUE_STORAGE_KEY, normalizedLeagueId);
  emitActiveLeagueChange(normalizedLeagueId);
};

export const clearStoredActiveLeagueId = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(ACTIVE_LEAGUE_STORAGE_KEY);
  emitActiveLeagueChange('');
};

export const useActiveLeagueId = () => {
  const [activeLeagueId, setActiveLeagueId] = useState(() => getStoredActiveLeagueId());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const syncActiveLeagueId = () => {
      setActiveLeagueId(getStoredActiveLeagueId());
    };

    window.addEventListener('storage', syncActiveLeagueId);
    window.addEventListener(ACTIVE_LEAGUE_CHANGE_EVENT, syncActiveLeagueId);

    return () => {
      window.removeEventListener('storage', syncActiveLeagueId);
      window.removeEventListener(ACTIVE_LEAGUE_CHANGE_EVENT, syncActiveLeagueId);
    };
  }, []);

  return activeLeagueId;
};

export const getLeaguePath = (leagueId, fallbackPath = '/leagues') => {
  const normalizedLeagueId = normalizeLeagueId(leagueId);
  return normalizedLeagueId ? `/leagues/${encodeURIComponent(normalizedLeagueId)}` : fallbackPath;
};